export const Arabic = {
  Features: "الميزات",
  Blog: "المدونة",
  Trade: "التجارة",
  trade: "التجارة",
  Buy: "شراء/بيع",
  Download: "تنزيل",
  The: "ال",
  gateway: "بوابة",
  to: "إلى",
  To: "إلى",
  the: "ال",
  next: "التالي",
  generation: "جيل",
  of: "من",
  Gamers: "اللاعبين",
  Your: "الخاصة بك",
  games: "الألعاب",
  coins: "العملات",
  All: "الكل",
  in: "في",
  one: "واحد",
  place: "مكان",
  Simple: "بسيط",
  fun: "ممتع",
  and: "و",
  And: "و",
  super: "رائع",
  smart: "ذكي",
  Scan: "مسح",
  download: "تنزيل",
  app: "تطبيق",
  Available: "متاح",
  on: "على",
  assets: "الأصول",
  Assets: "الأصول",
  Game: "لعبة",
  game: "لعبة",
  Connect: "اتصال",
  thirdparty: "جهة ثالثة",
  Crypto: "عملة رقمية",
  Card: "بطاقة",
  Authentication: "المصادقة",
  Own: "امتلك",
  your: "الخاصة بك",
  earn: "كسب",
  is: "هو",
  Is: "هو",
  easy: "سهل",
  way: "الطريق",
  store: "متجر",
  manage: "إدارة",
  winnings: "الأرباح",
  Whether: "سواء",
  youre: "أنت",
  Youre: "أنت",
  competitive: "تنافسي",
  gamer: "لاعب",
  or: "أو",
  just: "فقط",
  casual: "عارض",
  player: "لاعب",
  has: "لديه",
  something: "شيء",
  for: "لـ",
  everyone: "الجميع",
  effortlessly: "بسهولة",
  converts: "يحول",
  into: "إلى",
  preferred: "المفضل",
  cryptocurrency: "العملة المشفرة",
  start: "بدء",
  earning: "كسب",
  Exclusive: "حصري",
  content: "المحتوى",
  experiences: "تجارب",
  now: "الآن",
  at: "في",
  fingertips: "أطراف الأصابع",
  passport: "جواز سفر",
  unlock: "إلغاء القفل",
  favourite: "المفضل",
  need: "تحتاج",
  do: "فعل",
  connect: "اتصال",
  any: "أي",
  other: "آخر",
  Gaming: "الألعاب",
  Platform: "المنصة",
  account: "الحساب",
  Once: "مرة واحدة",
  connected: "متصل",
  youll: "ستكون",
  Youll: "ستكون",
  be: "سيكون",
  able: "قادر",
  rewards: "مكافآت",
  unlocking: "فتح",
  instantly: "في الحال",
  enjoying: "التمتع",
  powered: "مدعوم",
  by: "بواسطة",
  will: "سي",
  launch: "إطلاق",
  token: "رمز",
  listing: "قائمة",
  major: "رئيسي",
  coming: "قادم",
  soon: "قريبًا",
  participate: "المشاركة",
  our: "لدينا",
  premium: "ممتاز",
  collections: "مجموعات",
  you: "أنت",
  You: "أنت",
  must: "يجب",
  signup: "التسجيل",
  get: "الحصول على",
  verified: "تحقق",
  buy: "شراء",
  using: "باستخدام",
  respectively: "على التوالي",
  Smartest: "الأذكى",
  Safe: "آمن",
  Secure: "آمن",
  Earn: "كسب",
  Big: "كبير",
  Join: "انضم",
  Trend: "اتجاه",
  Dont: "لا ت",
  left: "ترك",
  behind: "وراء",
  Welcome: "مرحبًا",
  world: "العالم",
  possibilities: "احتمالات",
  space: "المساحة",
  no: "لا",
  longer: "بعد",
  thing: "شيء",
  it: "إنه",
  present: "حاضر",
  Over: "أكثر من",
  invested: "مستثمر",
  projects: "مشاريع",
  past: "الماضي",
  year: "سنة",
  free: "مجاني",
  easiest: "أسهل",
  anywhere: "في أي مكان",
  anytime: "في أي وقت",
  Use: "استخدام",
  accepted: "مقبول",
  from: "من",
  online: "عبر الإنترنت",
  globally: "عالميًا",
  With: "مع",
  an: "مع",
  instant: "فوري",
  cash: "نقدًا",
  conversions: "تحويلات",
  can: "يمكن",
  spend: "إنفاق",
  without: "دون",
  hassles: "مشاكل",
  top: "أعلى",
  notch: "ممتاز",
  security: "أمان",
  blockchain: "سلسلة الكتل",
  backbone: "العمود الفقري",
  are: "هي",
  always: "دائماً",
  safe: "آمن",
  perfect: "مثالي",
  most: "معظم",
  out: "خارج",
  Rewarding: "مجزٍ",
  complete: "كامل",
  control: "التحكم",
  over: "فوق",
  funds: "الأموال",
  while: "بينما",
  prioritizing: "التفضيل",
  gaming: "الألعاب",
  back: "إلى الوراء",
  with: "مع",
  every: "كل",
  use: "استخدام",
  today: "اليوم",
  level: "مستوى",
  up: "إلى الأعلى",
  rules: "القوانين",
  only: "فقط",
  keys: "المفاتيح",
  so: "لذلك",
  Our: "لدينا",
  audited: "تم مراجعته",
  audit: "مراجعة",
  firms: "الشركات",
  constantly: "باستمرار",
  reviewed: "مراجع",
  ensure: "ضمان",
  maximum: "أقصى",
  Convenience: "الراحة",
  moment: "لحظة",
  WAYS: "الطرق",
  AUTHENTICATION: "المصادقة",
  TO: "إلى",
  STRENGTHEN: "تعزيز",
  YOUR: "الخاصة بك",
  ASSETS: "الأصول",
  SAFETY: "السلامة",
  enjoy: "تمتع",
  all: "الكل",
  this: "هذا",
  amazing: "رائع",
  functionalities: "وظائف",
  A: "A",
  Decentralized: "لامركزي",
  wallet: "محفظة",
  dedicated: "مخصص",
  Home: "الصفحة الرئيسية",
  Marketplace: "السوق",
  Privacy: "الخصوصية",
  Policy: "السياسة",
  Terms: "الشروط",
  Service: "الخدمة",
  Navigation: "التصفح",
  Products: "المنتجات",
  Legal: "قانوني",
  What: "ماذا",
  How: "كيف",
  blockchains: "سلاسل الكتل",
  does: "يفعل",
  support: "يدعم",
  types: "أنواع",
  withdraw: "ينسحب",
  deposit: "إيداع",
  earned: "حصل",
  my: "لي",
  I: "أنا",
};
